import { ButtonSelectControlContent } from '../ButtonSelectControlContent'

/**
 * Button select control content without selected items inside.
 * Can be used for multi item select.
 */
function ButtonMultiSelectControlContent(props) {
  return <ButtonSelectControlContent {...props} ValueItem={null} />
}

export default ButtonMultiSelectControlContent
